import fullSlider from '../components/full-slider';
import downloadBlock from '../components/download-block';
import timelineSlider from '../components/timeline-slider';
import scrollTo from '../helpers/scroll-to';
import availability from '../components/availability';
import googleMap from '../components/map';

export default () => {
  const links =
  fullSlider();
  downloadBlock();
  timelineSlider();
  scrollTo({
    selector: '[data-scroll]'
  });
  availability();
  googleMap();
}
